import { Label } from "@/components/ui/label"
import { ParametersOverviewParameterProps, ParametersOverviewSectionProps, ParametersOverviewTabProps } from "."
import { CircleAlert, Eye, EyeOff } from "lucide-react"
import { Link, useParams } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useState } from "react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"

export function ParametersOverviewTab({ exportData }: ParametersOverviewTabProps) {
    const { orgId } = useParams<{ orgId: string }>()
    return (
        <div className="">
            <div className="flex justify-end">
                <Link to={`/organization/${orgId}/manage-organization`}>
                    <Button size='sm'>
                        Edit Parameters Values
                    </Button>
                </Link>
            </div>
            <ParametersOverviewSection
                parameter={exportData?.matched_configuration_with_default?.parameter?.crm}
                label="CRM"
            />
            <ParametersOverviewSection
                parameter={exportData?.matched_configuration_with_default?.parameter?.project}
                label="Project"
            />
            <ParametersOverviewSection
                parameter={exportData?.matched_configuration_with_default?.parameter?.survey}
                label="Survey"
            />
        </div>
    )
}

function ParametersOverviewSection({ parameter, label }: ParametersOverviewSectionProps) {
    return (
        <div className="space-y-2">
            <Label>{label} parameters</Label>
            {parameter && parameter.length > 0 ? (
                <div className="space-y-2">
                    {parameter.map((parameter) => (
                        <ParametersOverviewParameter
                            key={parameter.name}
                            parameter={parameter}
                        />
                    ))}
                </div>
            ) : (
                <p className="pb-2 text-sm text-muted-foreground">No {label} parameters</p>
            )}
        </div>
    )
}

function ParametersOverviewParameter({ parameter }: ParametersOverviewParameterProps) {
    const [show, setShow] = useState(parameter?.settings?.isPrivate ? false : true)
    return (
        <TooltipProvider>
            <div
                className="flex items-center gap-2 px-2 py-1 border rounded-md bg-lighter-gray data-[error=true]:bg-red-500/40 data-[error=true]:border-red-500/30 w-full"
                data-error={!parameter?.value}
            >
                <Tooltip>
                    <TooltipTrigger className="flex justify-between w-full min-w-0">
                        <p className="mr-2 whitespace-nowrap">{parameter?.name}:</p>
                        <p className="min-w-0 truncate">
                            {parameter?.value ? show ? parameter?.value : '**********' : <span className="flex items-center gap-1"> <CircleAlert size={16} /> No value specified</span>}
                        </p>
                    </TooltipTrigger>
                    <TooltipContent>
                        {parameter?.value ? show ? parameter?.value : '**********' : <span className="flex items-center gap-1"> <CircleAlert size={16} /> No value specified</span>}
                    </TooltipContent>
                </Tooltip>
                {parameter?.settings?.isPrivate && (
                    <div className="flex-shrink-0 ml-2">
                        {show ? (
                            <Eye
                                size={16}
                                className="cursor-pointer"
                                onClick={() => setShow(false)}
                            />
                        ) : (
                            <EyeOff
                                size={16}
                                className="cursor-pointer"
                                onClick={() => setShow(true)}
                            />
                        )}
                    </div>
                )}
            </div>
        </TooltipProvider>
    )
}